import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { DynamicHeaderService } from '../../services/dynamic-header.service';


interface IeditHeaderModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-edit-dynamic-header',
  templateUrl: './edit-dynamic-header.component.html',
  styleUrls: ['./edit-dynamic-header.component.scss']
})
export class EditDynamicHeaderComponent implements OnInit {
  success:any;
  error:any;
 headerForm: FormGroup;
 pending:boolean;
 extraData: any;
 formSubmitAttempt: boolean;

 constructor(public modal: SuiModal<IeditHeaderModalContext
  , void, void>,
  private fb: FormBuilder,
private headerSvc:DynamicHeaderService) {
  this.headerForm = this.fb.group({
    headerKey: ['', Validators.required],
    headerValue: ['', Validators.required],
  });
  this.extraData = this.modal.context.data;
  this.headerForm.patchValue(this.extraData);
 }

ngOnInit(): void {
}
isFieldValid(field: string) {
  return (
    (!this.headerForm.get(field).valid &&
      this.headerForm.get(field).touched) ||
    (this.headerForm.get(field).untouched && this.formSubmitAttempt)
  );
  
}
displayFieldCss(field: string) {
  return {
    error: this.isFieldValid(field),
  };
}

add(){
  this.pending = false;
  if (this.headerForm.valid) {
    this.error = null;
    this.pending = true;
    this.success = null;
}
if (this.modal.context.data) {
this.headerSvc
  .addHeaderConfig({ 
    body: this.headerForm.value,
  }).
  subscribe({
    next: () => {
      this.pending = false;
      this.success= 'Header Added Successfully';
      setTimeout(() => this.modal.approve(), 500);
      window.location.reload();
    },
    error: (error: any) => {
      this.error = error?.error?.message
        ? error?.error?.message
        : error;
      this.pending = false;
    },
  });
}



}
update(){
this.pending = false;
  if (this.headerForm.valid) {
    this.error = null;
    this.pending = true;
    this.success = null;
}
if (this.modal.context.data) {
this.headerSvc
  .editHeaderConfig({
    headerConfigId: this.modal.context.data.headerConfigId,
    body: this.headerForm.value,
  }).
  subscribe({
    next: () => {
      this.pending = false;
      this.success= 'Header Updated Successfully';
      setTimeout(() => this.modal.approve(), 500);
      window.location.reload();
    },
    error: (error: any) => {
      this.error = error?.error?.message
        ? error?.error?.message
        : error;
      this.pending = false;
    },
  });
}

}
}


export class editDynamicHeaderModal extends ComponentModalConfig<
IeditHeaderModalContext,
void,
void
> {
constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
  super(EditDynamicHeaderComponent, { title, data });

  this.isClosable = false;
  this.transitionDuration = 200;
  this.transition = 'slide left';
  this.size = size;
  this.isFullScreen = false;
  this.isInverted = false;
}
}
